module.exports = __webpack_public_path__ + "img/abSportTitleBigBG.67ad5656.jpg";